import React from 'react';
import { FaCheckCircle } from 'react-icons/fa'; 
import '../styles/Hero.css';
import heroImage from '../assets/images/hero.webp';

function Hero() {
  return (
    <section id="home" className="d-flex align-items-center bg-light py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Texto do Hero */}
          <div className="col-lg-6 d-flex flex-column justify-content-center">
            <h1 className="display-4 fw-bold mb-4">
              Potencialize o <span className="text-primary">Seu Negócio</span> com
              <br /> <span className="text-success">Soluções Inovadoras</span>
            </h1>
            
            <ul className="list-unstyled mb-4">
              <li className="mb-2">
                <FaCheckCircle className="text-success me-2" />
                Integração de sistemas personalizada
              </li>
              <li className="mb-2">
                <FaCheckCircle className="text-success me-2" />
                Soluções escaláveis e seguras para empresas
              </li>
              <li>
                <FaCheckCircle className="text-success me-2" />
                Atendimento às necessidades específicas
              </li>
            </ul>

            {/* Botão menor e estilizado */}
            <a href="#contact" className="btn-primary btn-sm px-4 py-2">
              Comece Agora
            </a>
          </div>

          {/* Imagem do Hero */}
          <div className="col-lg-6 text-center">
            <img src={heroImage} className="img-fluid animate__animated animate__fadeInRight" alt="Hero" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
